/**
 * The size the canvas designer opens on. A bundle slot links here with
 * `?variant=`: that size opens preselected when it is one this product sells
 * (an explicit link beats a saved draft); otherwise the draft's, as before.
 */
export function initialCanvasVariantId(
  urlVariantId: string | null | undefined,
  variants: { id: string }[],
  restoredVariantId: string | null | undefined,
): string | null {
  if (urlVariantId && variants.some((v) => v.id === urlVariantId))
    return urlVariantId;
  return restoredVariantId ?? null;
}

/**
 * `?material=`: which finish the editor opens on. "canvas" means stretched
 * canvas (the framed one, what "Na platnu" sells); "paper" means photo paper.
 * Anything else leaves the default (the entry enlargement's finish).
 */
export function finishForMaterialParam(
  value: string | null | undefined,
): { material: string; mount?: string } | undefined {
  if (value === "canvas") return { material: "canvas", mount: "stretched" };
  if (value === "paper") return { material: "paper" };
  return undefined;
}
